export default __webpack_public_path__ + "static/media/Geologica-Medium.511acc58.ttf";